import { on, Action } from '@ngrx/store';
import { createImmerReducer } from 'ngrx-immer/store';
import * as JobseekerActions from './actions';
import { IndustryState } from './state';

const initialState: IndustryState = {
  industries: [],
  loading: false,
};

const reducer = createImmerReducer(
  initialState,
  on(JobseekerActions.getJobseekerIndustryList, (state) => {
    state.loading = true;

    return state;
  }),

  on(JobseekerActions.getJobseekerIndustryListSuccess, (state, { payload }) => {
    state.industries = payload;
    state.loading = false;

    return state;
  }),

  on(JobseekerActions.getJobseekerIndustryListFail, (state, { payload }) => {
    state.loading = false;

    return state;
  }),
);

export function industryListReducer(
  state: IndustryState | undefined,
  action: Action
) {
  return reducer(state, action);
}
